import ItemWrapper from "../ItemWrapper"
import ItemImage from "../ItemImage"
import ItemHeader from "../ItemHeader"

export default function BorderedItem({
  assembledItem,
  banned,
  setItemModalOpen,
  readOnly,
  menuItemParams,
}) {
  return (
    <ItemWrapper
      assembledItem={assembledItem}
      banned={banned}
      className={`orderItemListItem-root pl-2 hidden-content appear w-full border-y-1 border-x-0 border-[var(--order-items-card-border-color)]`}
      onClick={() => setItemModalOpen(true)}
    >
      <ItemHeader
        assembledItem={assembledItem}
        banned={banned}
        // nameClass="text-sm"
        readOnly={readOnly}
        menuItemParams={menuItemParams}
      />
      <ItemImage assembledItem={assembledItem} />
    </ItemWrapper>
  )
}
